























import { Component, Vue, Prop } from 'vue-property-decorator';
import itkClock from '../wxClock';

@Component({
    components: { itkClock },
})
export default class WxFooter extends Vue {
    @Prop(Number) private readonly idleSince!: number;
    @Prop(Number) private readonly logoutTimeout!: number;
    @Prop(String) private readonly lastMessage!: string;

    get minutesToLogout() {
        if (this.logoutTimeout === 0) return undefined;
        const timeoutMinutes = this.logoutTimeout / 60;
        const remainingMinutes = Math.ceil((this.logoutTimeout - this.idleSince) / 60);
        return remainingMinutes <= timeoutMinutes / 2 && remainingMinutes >= 1 ? remainingMinutes : undefined;
    }

    get secondsToLogout() {
        if (this.logoutTimeout === 0) return undefined;
        const remainingSeconds = this.logoutTimeout - this.idleSince;
        return remainingSeconds < 60 && remainingSeconds >= 1 ? remainingSeconds : undefined;
    }
}
